import { QUESTIONNAIRE_FLAGSMITH_KEYS } from '@resolve_medical_bills/flagsmith/keys';

/**
 * Flag values served when Flagsmith cannot be reached (e.g. org account
 * disabled / outage). The SDK uses these as `defaultFlags`, so `useGetFlagValue`
 * resolves to them instead of hanging on `ready = false`.
 *
 * Flip enabled/value here to change the outage experience. Once the live
 * Flagsmith account is restored these are simply overridden by real flags.
 */
export const FALLBACK_FLAGS: Record<string, { enabled: boolean; value: boolean }> = {
  [QUESTIONNAIRE_FLAGSMITH_KEYS.SHOW_NEW_FEATURE_V1]: { enabled: true, value: true },
  [QUESTIONNAIRE_FLAGSMITH_KEYS.EZ_FILE]: { enabled: true, value: true },
};
